<template>
    <VMenu
        class="EvaluationRuleBadge"
        popper-class="EvaluationRuleBadge__tooltip"
        placement="right"
        :delay="{ show: 100, hide: 100 }"
    >
        <Badge type="success">
            Evaluation Rule
        </Badge>
        <template #popper>
            <div class="EvaluationRuleBadge__popoverContent">
                <span>
                    Entities must meet the requirements for at least one of the requirements with this Evaluation Rule badge.
                </span>
                <span>
                    If requirements aren't met, all will be marked as non-compliant.
                </span>
            </div>
        </template>
    </VMenu>
</template>
<script lang="ts">
    import { Component, Vue } from '@evidentid/vue-property-decorator';

    import { Menu as VMenu } from 'floating-vue';

    import { faBalanceScaleLeft } from '@fortawesome/free-solid-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import { Badge } from '@evidentid/dashboard-commons/components/Badge';

    @Component({
        components: { Badge, FontAwesomeIcon, VMenu },
    })
    export default class EvaluationRuleBadge extends Vue {
        private faBalanceScaleLeft = faBalanceScaleLeft;
    }
</script>
